export default __webpack_public_path__ + "static/media/02.6de3ce07.jpg";